import imgOutside from '../../assets/buildings/hospital/outside.png';
import imgWasteWater from '../../assets/buildings/hospital/waste-water.webp';
import imgWater from '../../assets/buildings/hospital/water.webp';
import imgHeating from "../../assets/buildings/hospital/heating.png";
import imgFireProtection from '../../assets/buildings/hospital/fire-protection.png';
import { Building } from '../../interfaces/buildings';
import { ProductType } from '../products';
import { TechSector } from '../tech-sector';

const hospitalConfig: Building = {
    techSectors: [
            {
            type: TechSector.WASTE_WATER,
            img: imgWasteWater,
            products: [
                {
                        position: {x: 99, y: 937},
                    type: ProductType.AMAREX
                },
                {
                        position: {x: 1145, y: 678},
                    type: ProductType.AMA_DRAINER_BOX_UNTERFLUR
                },
                {
                        position: {x: 1437, y: 694},
                    type: ProductType.AMA_DRAINER_4_5
                },
                {
                        position: {x: 1547, y: 535},
                    type: ProductType.LEVELCONTROL_BASIC_2
                },
                {
                        position: {x: 1692, y: 558},
                    type: ProductType.COMPACTA
                },
            ]
        },
        {
            type: TechSector.FIRE_PROTECTION,
            img: imgFireProtection,
            products: [
                {
                        position: {x: 1082, y: 915},
                    type: ProductType.ETANORM_FXV
                },
                {
                        position: {x: 1448, y: 877},
                    type: ProductType.HYADUO_2_D_FL_COMPACT
                },
            ]
        },
        {
            type: TechSector.HEATING,
            img: imgHeating,
            products: [
                {
                        position: {x: 158, y: 564},
                    type: ProductType.BOAX_S_SF
                },
                {
                        position: {x: 235, y: 515},
                    type: ProductType.SERIE_2000
                },
                {
                        position: {x: 340, y: 569},
                    type: ProductType.ETANORM
                },
                {
                        position: {x: 409, y: 524},
                    type: ProductType.BOA_CONTROL_IMS
                },
                {
                        position: {x: 559, y: 459},
                    type: ProductType.SISTO_16_RGAMAXX
                },
                {
                        position: {x: 800, y: 474},
                    type: ProductType.BOA_CONTROL_DPR
                },
                {
                        position: {x: 871, y: 497},
                    type: ProductType.CALIO_PRO_PLUS_Z
                },
                {
                        position: {x: 972, y: 447},
                    type: ProductType.BOA_CONTROL_SBV
                },
                {
                        position: {x: 1068, y: 462},
                    type: ProductType.BOA_RVK
                },
                {
                        position: {x: 1167, y: 486},
                    type: ProductType.CALIO_PRO_PLUS
                },
                {
                        position: {x: 1269, y: 498},
                    type: ProductType.ETALINE_Z
                },
                {
                        position: {x: 1597, y: 439},
                    type: ProductType.BOATRONIC_MP
                },
            ]
        },
        {
            type: TechSector.WATER,
            img: imgWater,
            products: [
                {
                        position: {x: 495, y: 830},
                    type: ProductType.SISTO_16_TWA
                },
                {
                        position: {x: 664, y: 822},
                    type: ProductType.DELTA_PRIMO_SVP
                },
                {
                        position: {x: 961, y: 644},
                    type: ProductType.BOAX_S_SF
                },
                {
                        position: {x: 934, y: 599},
                    type: ProductType.MOVITEC
                },
                {
                        position: {x: 990, y: 800},
                    type: ProductType.BOA_COMPACT_EKB
                },
                {
                        position: {x: 1771, y: 860},
                    type: ProductType.UPA
                }
            ]
        },
    ],
    img: imgOutside
}

export default hospitalConfig;
